import { PatientsBirthdateChangeAction, IPatientBirthdateChangeRequest } from './patients.birthdate.change.types'

export const patientBirthdateChangeRequest = (params: IPatientBirthdateChangeRequest): PatientsBirthdateChangeAction =>
  ({ type: 'PATIENT_BIRTHDATE_CHANGE_REQUEST', params })

export const patientBirthdateChangeSuccess = (params: string): PatientsBirthdateChangeAction =>
  ({ type: 'PATIENT_BIRTHDATE_CHANGE_SUCCESS', params })

export const patientBirthdateChangeFailure = (): PatientsBirthdateChangeAction =>
  ({ type: 'PATIENT_BIRTHDATE_CHANGE_FAILURE' })